import { useState } from "react";
import { Play } from "lucide-react";

const VIDEO_ID = "zQnTFJAzrkc";
const TITLE = "How the Jee Tracker and study planner works";

/**
 * Lightweight YouTube facade: shows the poster image until the student taps
 * play, so the home page never pays for the embed on first load.
 */
export function HomeVideo() {
  const [playing, setPlaying] = useState(false);

  return (
    <div className="glass mx-auto w-full max-w-3xl overflow-hidden rounded-[26px] border-hairline">
      <div className="relative aspect-video w-full bg-black">
        {playing ? (
          <iframe
            className="absolute inset-0 size-full"
            src={`https://www.youtube-nocookie.com/embed/${VIDEO_ID}?autoplay=1&rel=0`}
            title={TITLE}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            loading="lazy"
          />
        ) : (
          <button
            type="button"
            onClick={() => setPlaying(true)}
            aria-label={`Play video: ${TITLE}`}
            className="group absolute inset-0 size-full"
          >
            <img
              src={`https://i.ytimg.com/vi/${VIDEO_ID}/hqdefault.jpg`}
              alt="Video walkthrough of the Jee Tracker study planner"
              width={1280}
              height={720}
              loading="lazy"
              decoding="async"
              className="size-full object-cover opacity-70 transition-opacity group-hover:opacity-85"
            />
            <span className="neural-gradient absolute left-1/2 top-1/2 grid size-16 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full shadow-[0_18px_40px_-18px_rgba(0,0,0,0.9)] transition-transform group-active:scale-95">
              <Play className="size-6 translate-x-0.5 fill-white text-white" />
            </span>
          </button>
        )}
      </div>
      <p className="px-4 py-3 text-xs text-muted-foreground">
        Watch how to set up your plan and track lectures, revision and tests.
      </p>
    </div>
  );
}
